// extracted by mini-css-extract-plugin
export default {"ModalBodyText":"webpack-pages-DataExtraction-DataExtractionTemplate-components-Modals-Modal-module__ModalBodyText"};